import { useDroppable } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import React from "react";
import { useKanbanColumnLabels } from "../../../constants/kanban";
import { Task } from "../../../models/Kanban";
import { KanbanBoardStatus } from "../../../types";
import KanbanCard from "./KanbanCard";
import SortableTaskItem from "./SortableTaskItem";

type BoardSectionProps = {
  id: string;
  status: KanbanBoardStatus;
  tasks: Task[];
  lastIndex: boolean;
  setCampaignId?: React.Dispatch<React.SetStateAction<string>>;
};

const BoardSection = ({
  id,
  status,
  tasks,
  lastIndex,
  setCampaignId,
}: BoardSectionProps) => {
  const { setNodeRef } = useDroppable({
    id,
  });
  const columnLabels = useKanbanColumnLabels();
  return (
    <div className={`w-1/4 border-gray-300 ${lastIndex ? "" : "border-r-2"}`}>
      <h1 className="text-center mb-5 font-bold">
      {columnLabels[status]}
      </h1>
      <SortableContext
        id={id}
        items={tasks}
        strategy={verticalListSortingStrategy}
      >
        <div
          ref={setNodeRef}
          className="h-[500px] overflow-y-auto"
          aria-disabled={lastIndex}
          style={{ height: "500px" }}
        >
          {tasks.map((task) => (
            <div key={task.id}>
              <SortableTaskItem id={task.id}>
                <KanbanCard
                  taskId={task.id}
                  key={task.id}
                  name={task.name}
                  startDate={task.startDate || ""}
                  endDate={task.endDate || ""}
                  draft={task.status === "draft"}
                  isPermanent={task.isPermanent}
                  setCampaignId={setCampaignId}
                />
              </SortableTaskItem>
            </div>
          ))}
        </div>
      </SortableContext>
    </div>
  );
};

export default BoardSection;
